var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Directive, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
var CustomFuncValidatorDirective = /** @class */ (function () {
    function CustomFuncValidatorDirective() {
    }
    CustomFuncValidatorDirective_1 = CustomFuncValidatorDirective;
    CustomFuncValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    var CustomFuncValidatorDirective_1;
    __decorate([
        Input('custom-func-validate')
    ], CustomFuncValidatorDirective.prototype, "validator", void 0);
    CustomFuncValidatorDirective = CustomFuncValidatorDirective_1 = __decorate([
        Directive({
            selector: '[custom-func-validate][ngModel]',
            providers: [
                { provide: NG_VALIDATORS, useExisting: forwardRef(function () { return CustomFuncValidatorDirective_1; }), multi: true }
            ]
        })
    ], CustomFuncValidatorDirective);
    return CustomFuncValidatorDirective;
}());
export { CustomFuncValidatorDirective };
